import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgImageComparisonComponent } from './image-comparison.component';


@NgModule({
	declarations: [
		NgImageComparisonComponent
	],
	imports: [
		CommonModule
	],
	exports: [
		NgImageComparisonComponent
	]
})
export class NgImageComparisonModule { }
